<template lang="pug" src="./custom-about-us-sections.pug"></template>

<script>
export default {
  props: ['props'],
  mounted () {
    setTimeout(() => {
      this.$refs.fade.classList.add('custom-about-us-sections--fade')
    }, 10)
    setTimeout(() => {
      this.$refs.slide.forEach((image, i) => {
        image.classList.add('custom-about-us-sections__image--slide')
      })
    }, 100)
  }
}
</script>



// WEBPACK FOOTER //
// custom-about-us-sections.vue?673263e4